import StatusCode from "../../util/StatusCode";
import { Dispatch } from 'react';
import { Action, Reducer } from 'redux';
import { CacheRequestState, RequestState } from '../../models/RequestState';
import InstanceClient from '../../services/InstanceClient';
import { OneRosterCombineTeamListing, CoreOneRosterConfigurationCombinedTeam } from '../../models/CoreOneRosterConfigurationCombinedTeam';
import { PageResult } from "../../models/CoreModels";
import { SearchPageRequest } from "../../models/Requests";

enum OneRosterCombineTeamType {
    GET_COMBINED_TEAMS = 'GET_COMBINED_TEAMS',
    GET_GROUPS = 'GET_GROUPS',
    GET_ACTIVITIES = 'GET_ACTIVITIES',
    POST_GROUPS = 'POST_GROUPS'
}

export interface OneRosterCombineTeamActionState {
    groups: RequestState<OneRosterCombineTeamListing[]>
    activities: RequestState<OneRosterCombineTeamListing[]>
    combinedTeams: CacheRequestState<PageResult<CoreOneRosterConfigurationCombinedTeam>>
}

interface OneRosterCombineTeam_ListGroups extends Action<OneRosterCombineTeamType> {
    type: OneRosterCombineTeamType.GET_GROUPS,
    groups: RequestState<OneRosterCombineTeamListing[]>
}

interface OneRosterCombineTeam_ListActivities extends Action<OneRosterCombineTeamType> {
    type: OneRosterCombineTeamType.GET_ACTIVITIES,
    activities: RequestState<OneRosterCombineTeamListing[]>
}

interface OneRosterCombineTeam_GetCombinedTeams extends Action<OneRosterCombineTeamType> {
    type: OneRosterCombineTeamType.GET_COMBINED_TEAMS,
    combinedTeams: CacheRequestState<PageResult<CoreOneRosterConfigurationCombinedTeam>>
}

type OneRosterCombineTeamAction =
    OneRosterCombineTeam_ListGroups
    | OneRosterCombineTeam_ListActivities
    | OneRosterCombineTeam_GetCombinedTeams;


export const GetCombinedTeams = (moduleId: string, filter: Partial<SearchPageRequest> = {}) => (dispatch: Dispatch<OneRosterCombineTeam_GetCombinedTeams>) => {
    dispatch({
        type: OneRosterCombineTeamType.GET_COMBINED_TEAMS,
        combinedTeams: { code: StatusCode.PENDING }
    });
    const url = `/api/core/oneroster/combinedTeam/${moduleId}/combinedTeams`;
    InstanceClient.get<PageResult<CoreOneRosterConfigurationCombinedTeam>>(url, filter)
        .then(res =>
            dispatch({
                type: OneRosterCombineTeamType.GET_COMBINED_TEAMS,
                combinedTeams: { code: StatusCode.COMPLETE, data: res.data }
            }))
        .catch(error =>
            dispatch({
                type: OneRosterCombineTeamType.GET_COMBINED_TEAMS,
                combinedTeams: { code: StatusCode.ERROR, error }
            }))
};

export const GetOneRosterCombineTeamGroups = (moduleId: string) => (dispatch: Dispatch<OneRosterCombineTeam_ListGroups>) => {
    dispatch({
        type: OneRosterCombineTeamType.GET_GROUPS,
        groups: { code: StatusCode.PENDING }
    });

    const url = `/api/core/oneroster/combinedTeam/${moduleId}/groups`;
    InstanceClient.get<OneRosterCombineTeamListing[]>(url)
        .then(res =>
            dispatch({
                type: OneRosterCombineTeamType.GET_GROUPS,
                groups: { code: StatusCode.COMPLETE, data: res.data }
            }))
        .catch(error =>
            dispatch({
                type: OneRosterCombineTeamType.GET_GROUPS,
                groups: { code: StatusCode.ERROR, error }
            }))
}

export const GetOneRosterCombineTeamActivities = (moduleId: string) => (dispatch: Dispatch<OneRosterCombineTeam_ListActivities>) => {
    dispatch({
        type: OneRosterCombineTeamType.GET_ACTIVITIES,
        activities: { code: StatusCode.PENDING }
    });

    const url = `/api/core/oneroster/combinedTeam/${moduleId}/activities`;
    InstanceClient.get<OneRosterCombineTeamListing[]>(url)
        .then(res =>
            dispatch({
                type: OneRosterCombineTeamType.GET_ACTIVITIES,
                activities: { code: StatusCode.COMPLETE, data: res.data }
            }))
        .catch(error =>
            dispatch({
                type: OneRosterCombineTeamType.GET_ACTIVITIES,
                activities: { code: StatusCode.ERROR, error }
            }))
}

export const PostOneRosterCombineTeam = (moduleId: string, combinedTeam: CoreOneRosterConfigurationCombinedTeam) => {
    const url = `/api/core/oneroster/combinedTeam/${moduleId}`
    return InstanceClient.post(url, combinedTeam)
}

export const UpdateOneRosterCombineTeam = (moduleId: string, combinedTeam: CoreOneRosterConfigurationCombinedTeam) => {
    const url = `/api/core/oneroster/combinedTeam/${moduleId}`
    return InstanceClient.put(url, combinedTeam)
}

export const DeleteOneRosterCombineTeam = (moduleId: string, combinedTeam: CoreOneRosterConfigurationCombinedTeam) => {
    const url = `/api/core/oneroster/combinedTeam/${moduleId}`
    return InstanceClient.delete(url, null, combinedTeam)
}

const initialState: OneRosterCombineTeamActionState = {
    groups: { code: StatusCode.NONE },
    activities: {code: StatusCode.NONE},
    combinedTeams: { code: StatusCode.NONE }
}

export const reducer: Reducer<OneRosterCombineTeamActionState, OneRosterCombineTeamAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case OneRosterCombineTeamType.GET_GROUPS:
            return {
                ...state,
                groups: action.groups
            };
        case OneRosterCombineTeamType.GET_COMBINED_TEAMS:
            return {
                ...state,
                combinedTeams: action.combinedTeams
            };
        case OneRosterCombineTeamType.GET_ACTIVITIES:
            return {
                ...state,
                activities: action.activities
            };
        default:
            return state;
    } 
}